import { PageShell } from "../components/layout/PageShell";

const SECTIONS = [
  {
    title: "What I collect",
    body: "When you send an enquiry, Mary Pawpins collects the details you choose to share: your name, email address, phone number, general location, and information about your pets and the care you are looking for. Nothing else is asked for at the enquiry stage.",
  },
  {
    title: "How it's used",
    body: "Your details are used only to respond to your enquiry, discuss availability and suitability, and arrange services if you decide to book. They are never sold, rented or shared with third parties for marketing.",
  },
  {
    title: "How it's stored",
    body: "Enquiry details are stored securely and kept only for as long as they are needed to manage your enquiry and any ongoing service. Home addresses, keys and detailed care records are arranged privately and securely once a booking is agreed, never through the public website.",
  },
  {
    title: "Photographs & reviews",
    body: "Photographs of pets and words from client reviews appear on this website only with the owner's permission. If you would like a photo or review of your pet removed, just ask and it will be taken down promptly.",
  },
  {
    title: "Website analytics",
    body: "This site uses privacy-conscious analytics to understand how visitors use the pages, so the website can be improved. No advertising trackers are used.",
  },
  {
    title: "Your rights",
    body: "You can ask at any time to see the personal information held about you, to have it corrected, or to have it deleted. To do so, contact Carly at marypawpinsinverness@gmail.com or 07749 040175.",
  },
];

export default function PrivacyPage() {
  return (
    <PageShell title="Privacy">
      <section className="pt-20 pb-8 sm:pt-28 sm:pb-10" data-testid="privacy-hero">
        <div className="max-w-3xl mx-auto px-6 sm:px-8">
          <p className="eyebrow">Privacy</p>
          <h1 className="font-serif text-4xl sm:text-5xl font-medium text-[#292A26] tracking-tight mt-4" data-testid="privacy-heading">
            Your details, treated properly.
          </h1>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#575953]">
            A small business handling personal information with the same care as the pets.
            Here's exactly what happens with your details.
          </p>
        </div>
      </section>

      <section className="pb-20" data-testid="privacy-content">
        <div className="max-w-3xl mx-auto px-6 sm:px-8 space-y-4">
          {SECTIONS.map((s, i) => (
            <div key={s.title} className="bg-white rounded-2xl border border-[#DDD7CB] p-7" data-testid={`privacy-section-${i}`}>
              <h2 className="font-serif text-xl font-medium text-[#292A26]">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-[#575953]">{s.body}</p>
            </div>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
